import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { DndProvider } from 'react-dnd';
import Backend from 'react-dnd-html5-backend';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { isIE } from 'react-device-detect';

import App from './App';
import { USE_AXL, OFFLINE } from './Config';

const init = (axl, params) => {

  ReactDOM.render(
    <DndProvider backend={Backend}>
      <BrowserRouter>
        <App axl={axl} params={params} />
      </BrowserRouter>
      
    </DndProvider>,
    document.getElementById('root'),
  );
  
  serviceWorker.unregister();

}

if(isIE) {
  document.body.innerHTML =
  '<p style="color:#aaa;background:white;margin:0 10vw;display:flex !important;flex-direction:column;width:80vw;height:90%;position:absolute;align-items:center;justify-content:center;font-size:20px;line-height:30px;text-align:center;"><span>This experiment is not available Internet Explorer. </span><a style="margin-top:20px;color:#4285f4;text-decoration:none;" href="https://artsandculture.google.com">Return to Google Arts &amp; Culture</a></p>';
} else if(OFFLINE) {

  ReactDOM.render(<div>This URL is no longer active. Please go to <a href="https://artsandculture.google.com/preview/experiment/gQEd3RNgW2oxDg">this link instead</a> </div>,
    document.getElementById('root'),
  );
  
  serviceWorker.unregister();
  
} else {

if(USE_AXL) {

  const AxL = require('./utils/Axl').default;
  const axl = new AxL();
  axl.handshake().then((params) => {
    init(axl, params);
  });

} else {
  init(null, {
    allowEdit:false
  });
}

}
